import {SxProps} from "@mui/material";
import {grayDefault} from "app/components/ThemeProvider/colors";

export const card: SxProps = {
    backgroundColor: 'white',
    p: '28px',
    boxShadow: '2px 2px 32px rgba(0, 0, 0, 0.06)',
    borderRadius: '8px'

}
export const mainText: SxProps = {
    fontSize: '20px',
    fontWeight: 600,
}
export const typeText: SxProps = {
    color: '#14191F8F',
    fontSize: '16px',
    fontWeight: 400
}
export const lineBorder: SxProps = {
    border: '1px dashed #eaeaea',
    width: '100%',
    mt: '24px',
};
